import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function BottomNav() {
	const location = useLocation();

	return (
		<div className='flex flex-col items-center gap-8 bg-success p-10 text-center'>
			<h2 className='font-heading text-2xl text-primary'>
				More from Marshall Academy Vocal Music
			</h2>
			<div className='flex flex-col gap-8 lg:flex-row'>
				<NavLink
					to='/about'
					className='btn btn-accent btn-lg w-80 rounded-sm font-lora normal-case lg:h-64 lg:w-64'
				>
					About
				</NavLink>
				<NavLink
					to={location.pathname === '/calendar' ? '/families' : '/calendar'}
					className='btn btn-success btn-lg w-80 rounded-sm border border-base-300 font-lora normal-case lg:h-64 lg:w-64'
				>
					{location.pathname === '/calendar' ? 'Families' : 'Calendar'}
				</NavLink>
				<NavLink
					to={
						location.pathname === '/' || location.pathname === '/gallery'
							? '/families'
							: '/gallery'
					}
					className='btn btn-primary btn-lg w-80 rounded-sm font-lora normal-case text-base-100 lg:h-64 lg:w-64'
				>
					{location.pathname === '/' || location.pathname === '/gallery'
						? 'Families'
						: 'Gallery'}
				</NavLink>
			</div>
		</div>
	);
}

export default BottomNav;
